export default {
  title: 'Novo item',
  title_edit: 'Editando item',
  'sections.basicInfo': 'Informações básicas',
  'sections.controlInfo': 'Dados de controle',
  'sections.stockInfo': 'Informações de estoque',
  'sections.buyInfo': 'Informações de compra',
  'sections.sellInfo': 'Informações de venda',
  'sections.othersInfo': 'Outras informações',
  'fields.name': 'Nome',
  'fields.code': 'Código do produto',
  'fields.subCategory': 'Subcategoria',
  'fields.brand': 'Marca',
  'fields.model': 'Modelo',
  'fields.supplier': 'Fornecedor',
  'fields.sizeUnit': 'Unidade de medida',
  'fields.description': 'Descrição',
  'fields.enabled': 'Ativo',
  'fields.amount': 'Quantidade em estoque',
  'fields.minAmount': 'Estoque mínimo',
  'fields.maxAmount': 'Estoque máximo',
  'fields.criticalAmount': 'Volume crítico',
  'fields.warningAmount': 'Volume alerta',
  'fields.notificationEmails': 'E-mails de alerta',
  'fields.purchasePrice': 'Preço de custo',
  'fields.purchaseTax': 'Impostos',
  'fields.currency': 'Moeda',
  'fields.salesPrice': 'Preço de venda',
  'fields.maxDiscount': 'Desconto máximo permitido',
  'fields.salesTax': 'Impostos sobre vendas',
  'fields.barCode': 'Código de barras',
  'fields.notes': 'Observações',
  'fields.images': 'Imagens',
  'fields.addFile': 'Adicionar Arquivo',
  'validation.required': 'Campo obrigatório',
  'validation.amountGreaterThanZero': 'Quantidade deve ser maior que zero',
  'validation.invalidEmails': 'Um ou mais emails inválidos',
  'validation.duplicateEmails': 'Um ou mais emails duplicados',
  'bulkTransfer.title': 'Transferências',
  'bulkTransfer.fields.status': 'Status',
  'bulkTransfer.fields.item': 'Item',
  'bulkTransfer.fields.operation': 'Operação',
  'bulkTransfer.fields.user': 'Usuário',
  'bulkTransfer.fields.place': 'Local',
  'bulkTransfer.fields.amount': 'Quantidade',
  'bulkTransfer.validation.required': 'Campo obrigatório',
  'bulkTransfer.validation.amountNotNegative': 'Quantidade não pode ser menor que zero',
  'bulkTransfer.validation.amountGreaterThanZero': 'Quantidade deve ser maior que zero',
  'bulkTransfer.actions.execute': 'Executar',
  'bulkTransfer.actions.close': 'Fechar',
  'statusTag.pending': 'Pendente',
  'statusTag.success': 'Sucesso',
  'statusTag.error': 'Erro',
  'statusTag.insufficientAmount': 'Quantidade insuficiente',
  'statusTag.amountGreaterThanZero': 'Quantidade deve ser maior que zero',
  'statusTag.genericError': 'Erro genérico',
  'tooltip.item': 'Item',
  'tooltip.amount': 'Quantidade',
  'tooltip.operation': 'Operação',
  'tooltip.error': 'Erro'
}
